import { useQuery } from '@tanstack/react-query';

import { ICounterpartyOrdersParams } from '@app/models/interfaces';
import { Module } from '@app/models/users';
import Api from '@app/services/api';

import { ALL_TAB, IOrdersPage, OrdersTab } from '../interfaces';

export const hasOrdersEndpoint = (tab: OrdersTab): boolean =>
  tab === ALL_TAB || tab === Module.Warehouse || tab === Module.Delivery;

const fetchOrders = (tab: OrdersTab, params: ICounterpartyOrdersParams): Promise<IOrdersPage> => {
  if (tab === Module.Warehouse) {
    return Api.orders.getCounterpartyWarehouseOrders(params);
  }
  if (tab === Module.Delivery) {
    return Api.orders.getCounterpartyDeliveryOrders(params);
  }
  return Api.orders.getCounterpartyOrders(params);
};

export const useCounterpartyOrdersQuery = (tab: OrdersTab, params: ICounterpartyOrdersParams) =>
  useQuery({
    queryKey: ['counterpartyOrders', tab, params],
    queryFn: () => fetchOrders(tab, params),
    enabled: hasOrdersEndpoint(tab),
    keepPreviousData: true,
  });

// Счётчики вкладок - все заказы каждой вкладки, без учёта фильтров
export const useCounterpartyOrdersCountsQuery = () =>
  useQuery({
    queryKey: ['counterpartyOrders', 'counts'],
    queryFn: () => Api.orders.getCounterpartyOrdersCounts(),
  });

export const useCounterpartyOrderCustomersQuery = () =>
  useQuery({
    queryKey: ['counterpartyOrderCustomers'],
    queryFn: () => Api.orders.getCounterpartyOrderCustomers(),
  });

export const counterpartyOrderQueryKey = (uid: string) => ['counterpartyOrder', uid];

export const useCounterpartyOrderQuery = (uid: string) =>
  useQuery({
    queryKey: counterpartyOrderQueryKey(uid),
    queryFn: () => Api.orders.getCounterpartyOrder(uid),
    enabled: !!uid,
  });
